export const sliderData = [
    {
        "type": "gif",
        "gifUrl": "/assets/imgs/sliderHome/Home Background/custom_sky_effect.gif", // URL del GIF
        "altText": "GIF mostrando mantenimiento a gran altura", // Texto alternativo
        "titleLine1": "HABLEMOS DE",
        "titleLine2": "MANTENIMIENTO",
        "highlight": "A GRAN ALTURA",
        "labelText": "EDIFICIOS & ESTRUCTURAS",
        "labelColor": "#E30613"
    }
];

export const sliderDataEn = [
    {
        "type": "gif",
        "gifUrl": "/assets/imgs/sliderHome/Home Background/custom_sky_effect.gif", // URL del GIF
        "altText": "GIF showing maintenance at great heights", // Texto alternativo
        "titleLine1": "LET'S TALK ABOUT",
        "titleLine2": "MAINTENANCE",
        "highlight": "AT GREAT HEIGHTS",
        "labelText": "BUILDINGS & STRUCTURES",
        "labelColor": "#E30613"
    }
];
